/**
 * QA quick-login types and shared password constant.
 *
 * Account rows are loaded from GET /auth/qa-accounts/ (staging only).
 */

/** Default password for QA quick-login (must match backend user/qa_password.py). */
export const QA_DEFAULT_PASSWORD = "tnnqa2026";

export const DEMO_TENANT_SLUG = "memphis-rox";

export type QaAccount = {
  label: string;
  email: string;
  tenantSlug: string;
  roleLabel: string;
};

export type QaAccountGroup = {
  id: string;
  label: string;
  accounts: QaAccount[];
};

/** Unique key for deduplication tests. */
export function qaAccountKey(account: QaAccount): string {
  return `${account.email}::${account.tenantSlug}`;
}

type QaAccountApiRow = {
  email: string;
  label: string;
  role_label: string;
  tenant_slug: string | null;
};

type QaAccountGroupApiRow = {
  id: string;
  label: string;
  accounts: QaAccountApiRow[];
};

/** Map API snake_case rows to frontend QaAccountGroup[]. */
export function mapQaAccountGroups(
  groups: QaAccountGroupApiRow[] | undefined,
): QaAccountGroup[] {
  if (!Array.isArray(groups)) return [];

  return groups.map((group) => ({
    id: group.id,
    label: group.label,
    accounts: group.accounts.map((account) => ({
      email: account.email,
      label: account.label,
      roleLabel: account.role_label,
      tenantSlug: account.tenant_slug ?? "",
    })),
  }));
}
